import { apiSlice } from './index'
import { signup } from '../features/auth/session/sessionSlice'
import type {
	InitResponse,
	LoggedData,
	Session,
	SigninFormRequest,
	SignupFormRequest,
	SignupFormResponse,
	LoginFormResponse
} from '../features/auth/session/sessionSlice';
import { init, login, AuthRequest } from '../features/auth/session/sessionSlice';

const authApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		signup: builder.mutation<SignupFormResponse, SignupFormRequest>({
			query: (body) => {
			   return {
			   url:	   '/auth/signin',
			   method: 'POST',
			   body,
			   }
			},
			// */
			invalidatesTags:[],
			// https://redux-toolkit.js.org/rtk-query/api/createApi#onquerystarted
			async onQueryStarted(id, { dispatch, queryFulfilled }) {
				// onStart side-effect
				//dispatch()
				try {
					const {data } = await queryFulfilled
					localStorage.setItem('session', data.toString())
					// JSON.parse(localStorage.getItem("teeMeasuresAverages") || "")
					// on success side-effect
					if (data.data) {
						dispatch(login(data.data))
					}
					console.log("is this the good place to navigate");
				} catch (err) {
					//onError side-effect
					//dispatch('error fetching')
					console.log("arf error while trying to login");
				}
			}
		}),
	}),
})

export const { useSignupMutation } = authApi
